import moment from "moment";

export const DAYS = [
  "MONDAY",
  "TUESDAY",
  "WEDNESDAY",
  "THURSDAY",
  "FRIDAY",
  "SATURDAY",
  "SUNDAY",
];

export function getHoursSummary(location) {
  if (!location.HOURS) {
    return "Never";
  }

  let {OPEN, CLOSE, CLOSED} = getRegularHours(location, new Date());
  let currentEpoch = moment().valueOf();

  if (!CLOSED && currentEpoch < OPEN) {
    return `Opens at ${moment(OPEN).format("h:mm A")}`;

  } else if (!CLOSED && currentEpoch < CLOSE) {
    return `Closes at ${moment(CLOSE).format("h:mm A")}`;
  }

  return findNextOpenDayString(location);
}

function findNextOpenDayString(location) {
  let {startOfDay, day} = getDay(new Date());
  let dayIndex = DAYS.findIndex(item => item === day);

  let foundOpenDay = false;
  for (let count = 0; count < 7 && !foundOpenDay; count++) {
    dayIndex = goForwardDay(dayIndex);

    let {OPEN_OFFSET, CLOSE_OFFSET, CLOSED} = getRegularHoursOffsets(location, DAYS[dayIndex]);

    if (!CLOSED) {
      foundOpenDay = true;
      moment(startOfDay + OPEN_OFFSET);
      let caseifyDay = DAYS[dayIndex].charAt(0) + DAYS[dayIndex].substring(1).toLowerCase()
      return `Open on ${caseifyDay} at ${moment(startOfDay + OPEN_OFFSET).format("h:mm A")}`
    }
  }
}

export function withinFullHours(location, date, ignoreYesterdayAccounting = false, hours = "HOURS") {
  const fullHours = getHours(location, date, ignoreYesterdayAccounting, hours);

  return fullHours && fullHours.OPEN < moment(date).valueOf() && moment(date).valueOf() < fullHours.CLOSE;
}

export function getHours(location, date, ignoreYesterdayAccounting = false, hours = "HOURS"){
  let {OPEN_OFFSET, CLOSE_OFFSET, CLOSED} = getHoursOffsets(location, date, ignoreYesterdayAccounting, hours);

  if(CLOSED){
    return null;
  }

  let {startOfDay} = getDay(date, ignoreYesterdayAccounting);
  return {OPEN: startOfDay + OPEN_OFFSET, CLOSE: startOfDay + CLOSE_OFFSET};
}

function getHoursOffsets(location, date, ignoreYesterdayAccounting, hours = "HOURS"){
  let {startOfDay, day} = getDay(date, ignoreYesterdayAccounting);

  //Check closings first
  let closing = location.CLOSINGS.find((item) => {
    return (
      moment(startOfDay).isSameOrAfter(item.START_DATE) &&
      moment(startOfDay).isSameOrBefore(item.END_DATE)
    );
  });

  if (closing?.TYPE === "FULL_DAY_CLOSING") {
    return {OPEN_OFFSET: 0, CLOSE_OFFSET: 0, CLOSED: true, CLOSING_REASON: closing.NAME};

  } else if (closing?.TYPE === "SPECIAL_HOURS" && hours === "HOURS") {
    return {OPEN_OFFSET: closing.START_TIME*60000, CLOSE_OFFSET: closing.END_TIME*60000, CLOSED: false};
  }

  return getRegularHoursOffsets(location, day, hours);
}

function getRegularHours(location, date, ignoreYesterdayAccounting, hours) {
  let {startOfDay, day} = getDay(date, ignoreYesterdayAccounting);
  let {OPEN_OFFSET, CLOSE_OFFSET, CLOSED} = getRegularHoursOffsets(location, day, hours);

  return {
    OPEN: OPEN_OFFSET + startOfDay,
    CLOSE: CLOSE_OFFSET + startOfDay,
    CLOSED
  }
}

/*
  Returns open offset, closed offset of milliseconds past the start of the day
 */
function getRegularHoursOffsets(location, day, hours) {
  //If delivery hours is empty, default to store hours
  if (!location[hours]) {
    hours = "HOURS"
  }

  let rawOpen = location[hours][day + "_OPEN"],
    rawClose = location[hours][day + "_CLOSE"];

  if (
    ("" + rawOpen).toUpperCase() === "CLOSED" ||
    ("" + rawClose).toUpperCase() === "CLOSED" || !rawOpen || !rawClose
  ) {
    return {OPEN_OFFSET: 0, CLOSE_OFFSET: 0, CLOSED: true}
  }

  let open = moment(rawOpen),
    close = moment(rawClose);

  return {
    OPEN_OFFSET: (open.toDate().getTime() - open.startOf("day").toDate().getTime()),
    CLOSE_OFFSET: (close.toDate().getTime() - open.startOf("day").toDate().getTime()),
    CLOSED: false
  };
}

function getDay(date, ignoreYesterdayAccounting) {
  let day = getISODay(date);

  let startOfDay = moment(date).startOf("day");

  if (moment(date).hours() <= 4 && !ignoreYesterdayAccounting) {
    day = goBackDay(day);
    startOfDay.subtract(1, "day");
  }

  startOfDay = startOfDay.valueOf();
  return {startOfDay, day: DAYS[day]};
}

/**
 * Takes in date object
 * @param date
 * @returns {number|number}
 */
export function getISODay(date) {
  let day = date.getDay();
  day -= 1;

  return day === -1 ? 6 : day;
}

export function getOpeningsArrayFromToday(location) {
  let daysArray = getDayArrayFromToday();
  let currDate = new Date();

  let openingsArr = [];
  for (let day of daysArray) {
    openingsArr.push({
        dayName: DAYS[day].charAt(0) + DAYS[day].slice(1).toLowerCase(),
        ...getHoursOffsets(location, currDate, true)
      }
    );
    currDate = new Date(currDate.setDate(currDate.getDate() + 1));
  }

  return openingsArr;
}

export function getDayArrayFromToday() {
  let currDay = getISODay(new Date());
  let arr = [currDay];

  for (let count = 1; count < 7; count++) {
    currDay = goForwardDay(currDay);
    arr.push(currDay);
  }

  return arr;
}

function goForwardDay(day) {
  day = day + 1;
  if (day === 7) {
    return 0;
  }

  return day;
}

export function goBackDay(day) {
  day = day - 1;
  if (day === -1) {
    return 6;
  }
  return day;
}
